var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-quotes"},[_c('v-row',{staticClass:"d-flex justify-center"},[_c('h2',{staticClass:"section-quotes__title"},[_vm._v("Why customers love us")])]),_c('QuoteCarousel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }